import { useLocation } from 'react-router-dom';
/**
 * This hooks returns specified query params value
 * @param {string} name query param name
 * @returns {string | null} query params value
 */
export function useQueryParam(name: string) {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get(name);
}
